/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {TableHeaderEntryModel} from '../../../shared/table/models/table-header-entry.model';
import {PeriodsTableColumnEnum} from '../models/periods-table-column.enum';

const periodsTableHeadersConfiguration: {
    periodType: TableHeaderEntryModel<PeriodsTableColumnEnum>;
    timePeriod: TableHeaderEntryModel<PeriodsTableColumnEnum>;
    bundlesStatus: TableHeaderEntryModel<PeriodsTableColumnEnum>;
} = {
    periodType: {
        code: PeriodsTableColumnEnum.PERIOD_TYPE,
        name: 'Period type',
        sortable: false,
        widthWeight: 1
    },
    timePeriod: {
        code: PeriodsTableColumnEnum.TIME_PERIOD,
        name: 'Time period',
        sortable: false,
        widthWeight: 4,
    },
    bundlesStatus: {
        code: PeriodsTableColumnEnum.BUNDLES_STATUS,
        name: 'Bundles status',
        sortable: false,
        widthWeight: 1.5
    }
};

export default periodsTableHeadersConfiguration;
